import SrePlaySound from ".";

var storePlaySoundSessionSoundObject = function storePlaySoundSessionSoundObject(soundObj, soundLog) {
  return {
    type: SrePlaySound.PLAY_SOUND_SESSION_STORE_SOUND,
    payload: {
      soundObj: soundObj,
      soundLog: soundLog
    }
  };
};

var startPlaySoundSession = function startPlaySoundSession(sessionId, startTimeMS) {
  return {
    type: SrePlaySound.PLAY_SOUND_SESSION_START,
    payload: {
      sessionId: sessionId,
      startTimeMS: startTimeMS
    }
  };
};

var playSoundSessionProgress = function playSoundSessionProgress(session) {
  return {
    type: SrePlaySound.PLAY_SOUND_SESSION_PROGRESS,
    payload: {
      session: session
    }
  };
};

var playSoundSessionEnd = function playSoundSessionEnd(session) {
  var canceled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var silence = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: SrePlaySound.PLAY_SOUND_SESSION_END,
    payload: {
      session: session,
      canceled: canceled,
      silence: silence
    }
  };
};

export default {
  storePlaySoundSessionSoundObject: storePlaySoundSessionSoundObject,
  startPlaySoundSession: startPlaySoundSession,
  playSoundSessionProgress: playSoundSessionProgress,
  playSoundSessionEnd: playSoundSessionEnd
};